import React, { useEffect, useRef } from 'react'
import Floatingbutton from './Floatingbutton'
import Opentimelinemodal from '../Modals/Opentimelinemodal'
import Conformationmodal from '../Modals/Conformetionmodal'
import { connect } from 'react-redux'
import axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'

function Timeline({ userAccess }) {
  const wideBlockRef = useRef()
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [timelineData, setTimelineData] = React.useState([])
  const [inputData, setInputData] = React.useState([])

  useEffect(() => {
    fetchmyposts()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteTimeline = pollID => {
    setDeleteId(pollID)
    setShowConfirmModal(true)
  }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const handleConfirmDelete = async () => {
    if (!deleteId) return
    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      setTimelineData(prev => prev.filter(item => item.pollId !== deleteId))
      toast.success('Post deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete post')
    }
  }

  const fetchmyposts = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(`${config.apiUrl}/post/Updates`, {
        headers: { Authorization: token }
      })

      const normalized = (res.data.data || [])
        .filter(post => post.Type === 'Updates')
        .map(post => {
          let imageUrl = ''
          if (post?.Data?.ImageLink) {
            if (
              typeof post.Data.ImageLink === 'object' &&
              post.Data.ImageLink.data
            ) {
              imageUrl = String(post.Data.ImageLink.data)
            } else if (typeof post.Data.ImageLink === 'string') {
              imageUrl = post.Data.ImageLink
            }
          }
          return {
            pollId: post.ID,
            type: post.Type,
            title: post?.Data?.Title || '',
            image: imageUrl,
            CreatedOn: post.CreatedOn
          }
        })
        .sort((a, b) => b.pollId - a.pollId)
      setTimelineData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const ImageUploadtimeliene = async formData => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.post(`${config.apiUrl}/upload/image`, formData, {
        headers: {
          Authorization: token
        }
      })
      if (res.status === 200) {
        return res.data
      }
    } catch (e) {
      console.error('Image upload failed', e)
      toast.error('Image Upload Failed')
    }
  }

  const Postupload = async payload => {
    const token = localStorage.getItem('token')

    try {
      const postRes = await axios.post(
        `${config.apiUrl}/post/Updates`,
        payload,
        {
          headers: { Authorization: token }
        }
      )

      if (postRes.status === 200) {
        const apiPost = postRes.data?.data

        let imageUrl = ''
        if (apiPost?.Data?.ImageLink) {
          if (
            typeof apiPost.Data.ImageLink === 'object' &&
            apiPost.Data.ImageLink.data
          ) {
            imageUrl = apiPost.Data.ImageLink.data
          } else if (typeof apiPost.Data.ImageLink === 'string') {
            imageUrl = apiPost.Data.ImageLink
          }
        } else if (payload?.Data?.ImageLink?.data) {
          imageUrl = payload.Data.ImageLink.data
        }

        const newPost = {
          pollId: apiPost?.ID || Date.now(),
          type: apiPost?.Type || 'Updates',
          title: apiPost?.Data?.Title || payload.Data.Title || 'Untitled',
          image: imageUrl,
          CreatedOn: apiPost?.CreatedOn || new Date().toISOString()
        }

        

        setTimelineData(prev => [newPost, ...prev])
        toast.success('Post created successfully!')
        setShowModal(false)
      }
    } catch (e) {
      console.error('Post upload failed', e)
      toast.error('Failed to create post')
    }
  }
  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  return (
    <div id="appCapsule">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef}>
          <div className="timeline timed">
            {timelineData.map(item => (
              <div className="item" key={item.pollId}>
                <span className="time">
                  {item.CreatedOn
                    ? new Date(item.CreatedOn).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })
                    : '--'}
                  <br />
                  {item.CreatedOn
                    ? new Date(item.CreatedOn).toLocaleTimeString('en-IN', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      })
                    : '--'}
                </span>

                <div className={`dot ${item.dotColor}`}></div>
                <div className="content">
                  <div className="card p-3 position-relative">
                    {userAccess.includes('DeleteTimeline') && (
                      <div
                        className="rounded-circle position-absolute top-0 end-0 p-2"
                        style={{
                          backgroundColor: 'red',
                          boxShadow: '0 2px 2px rgba(0,0,0,0.2)',
                          cursor: 'pointer',
                          width: '56px',
                          height: '56px',
                          zIndex: 10
                        }}
                        onClick={() => handleDeleteTimeline(item.pollId)}
                      >
                        <ion-icon
                          name="trash"
                          style={{
                            fontSize: '24px',
                            color: 'white',
                            cursor: 'pointer'
                          }}
                        ></ion-icon>
                      </div>
                    )}
                    <div className="d-flex flex-column align-items-center">
                      {item.type === 'Updates' && item.image && (
                        <img
                          src={item.image}
                          alt="Timeline"
                          className="img-fluid rounded"
                          style={{ maxWidth: '100%' }}
                        />
                      )}
                      <h5 className="mt-2 mb-0 text-center w-100">
                        {item.title}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {userAccess.includes('CreateTimeline') && (
            <Floatingbutton onOpen={handlemodalOpen} />
          )}

          <Opentimelinemodal
            show={showModal}
            id={selectId}
            onImagetimeline={ImageUploadtimeliene}
            onSubmitpost={Postupload}
            inputData={inputData}
            fetchinputs={fetchinputs}
            onClose={() => setShowModal(false)}
          />

          <Conformationmodal
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  userAccess: auth.userAccess
})

export default connect(mapStateToProps)(Timeline)
